import { http } from '../utils/axios';
import { TStatesResponse } from 'shared/types';

class StatesService {
  private static instance: StatesService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): StatesService {
    if (!StatesService.instance) {
      StatesService.instance = new StatesService();
    }

    return StatesService.instance;
  }

  getAllStates = async () => {
    const { data } = await http<TStatesResponse>({
      url: '/states',
      method: 'GET'
    });

    return data;
  };
}

const instance = StatesService.getInstance();

export default instance;
